import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";
import $ from "jquery";
import Common from "../../src/pages/BOM/Common";
import Helper from "../../src/support/Helper";

let c = System.getParams();

class Bom {
    static BOM_LISTING = Helper.getBOMUrl() + '/api/bom/list';
    static CREATE_BOM = Helper.getBOMUrl() + '/api/bom/create';
    static EDIT_BOM = Helper.getBOMUrl() + '/api/bom/edit';
    static ADD_PART_TO_BOM = Helper.getBOMUrl() + '/api/bom/addpart';
    static BOM_DETAIL_BY_BOM_ID = Helper.getBOMUrl() + '/api/bom/get'
    static BOM_DELETE_BY_BOM_ID = Helper.getBOMUrl() + '/api/bom/delete'
    static BOM_COPY_BY_BOM_ID = Helper.getBOMUrl() + '/api/bom/createcopy'
    static BOM_HEALTH_BY_BOM_ID = Helper.getBOMUrl() + '/api/bom/bomHealth'
    static BOM_DETAIL_BY_BOM_ID_WITH_TYPE = Helper.getBOMUrl() + '/api/bom/detailsMatchType'
    static UPDATE_BOM_DETAIL_QUANTITY_BY_BOM_DETAIL_ID = Helper.getBOMUrl() + '/api/bom/updatequantity'
    static UPDATE_BOM_DETAIL_CUSTOMER_PART_NUMBER_BY_BOM_DETAIL_ID = Helper.getBOMUrl() + '/api/bom/updatecpn'
    static DOWNLOAD_BOM_TEMPLATE = Helper.getBOMUrl() + '/api/bom/downloadBomTemplate'
    static BOM_UPLOAD_FILE = Helper.getBOMUrl() + '/api/bom/bomUpload'
    static BOM_UPLOAD_FILE_PROGRESS = Helper.getBOMUrl() + '/api/bom/bomUploadProcess'
    static BOM_DETAIL_ALTERNATIVE_COUNT_CALL = Helper.getApplicationUrl() + '/api/application/product/bomalternative'
    static BOM_DOWNLOAD_FILE = Helper.getBOMUrl() + '/api/bom/bomDownload'
    static BOM_EMAIL_FILE = Helper.getBOMUrl() + '/api/bom/emailBom';
    static CREATE_PART_LIST = Helper.getBOMUrl() + '/api/bom/createpartlist'
    static SWAP_PART_NUMBER = Helper.getBOMUrl() + '/api/bom/swappartnumber'
    static REMOVE_PART_NUMBER = Helper.getBOMUrl() + '/api/bom/removepart'
    static ASSIGN_BOM_TO_PROJECT = Helper.getBOMUrl() + '/api/project/assignbom'
    static CREATE_PROJECT = Helper.getBOMUrl() + '/api/project/create'
    static EDIT_PROJECT = Helper.getBOMUrl() + '/api/project/edit'
    static FETCH_SINGLE_PROJECT = Helper.getBOMUrl() + '/api/project/get'
    static DELETE_PROJECT = Helper.getBOMUrl() + '/api/project/delete'
    static LIST_PROJECT = Helper.getBOMUrl() + '/api/project/list'
    static LIST_PROJECT_DETAIL_WITH_BOM = Helper.getBOMUrl() + '/api/project/bomlist'
    static BOM_REMATCH_COLUMN_DATA = Helper.getBOMUrl() + '/api/bom/columndata'
    static BOM_REMATCH_STATIC_COLUMN = Helper.getBOMUrl() + '/api/bom/columns'
    static BOM_SAVED_REMATCH_COLUMN_PREFERENCE = Helper.getBOMUrl() + '/api/bom/getcolumns'
    static BOM_SAVE_REMATCH_COLUMN_PREFERENCE = Helper.getBOMUrl() + '/api/bom/finishcolumnmapping'
    static BOM_SET_IS_REMATCH_FLAG_IN_BOM_DETAIL = Helper.getBOMUrl() + '/api/bom/rematch'
    static BOM_MULTIPLE_MATCH_PRODUCT_SEARCH = Helper.getBOMUrl() + '/api/bom/multipleproducts'
    static UPDATE_DISPLAY_ORDER = Helper.getBOMUrl() + '/api/bom/updatedisplayorder'
    static BOM_Farnell_LIST = Helper.getApplicationUrl() + '/api/application/farnell/getfarnellproductsforbom'

    //User Based
    static FETCH_DOWNLOAD_BOM_PREFERENCE = Helper.getUserUrl() + '/api/user/getUserPreference'
    static SAVE_DOWNLOAD_BOM_PREFERENCE = Helper.getUserUrl() + '/api/user/saveUserPreference'

    static getBomRouteURL() {
        return HCLDX.baseURL() + '/resources/my-avnet/bom';
    }

    static getBomTabsListRouteURL(extra_c = {}) {
        c[Common.param_key] = Common.chain.BomTabsList.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getBomRematchRouteURL(extra_c = {}) {
        c[Common.param_key] = Common.chain.BomRematch.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getBomProductListingRouteURL(bomId, extra_c = {}) {
        c[Common.param_key] = Common.chain.BomProductListing.param_value;
        c[Common.param_key_bomId] = bomId;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getBomDetailByIdRouteURL(bomId, extra_c = {}) {
        c[Common.param_key] = Common.chain.BomDetailById.param_value;
        c[Common.param_key_bomId] = bomId;
        delete c['search']
        delete c['ComingFromUniversalSearch']
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/my-avnet/bom?' + $.param(c);
    }
}

export default Bom;